import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Pages/Home';
import Footer from './Components/Utils/Footer';
import Navbar from './Components/Utils/Navbar';
import Biography from './Components/Pages/Biography';
import Projects from './Components/Pages/Projects';
import Contact from './Components/Pages/Contact';
import News from './Components/Pages/News';
import Internship from './Components/Pages/Internship';
import Faculty from './Components/Pages/Faculty';
import PostDoctoral from './Components/Pages/PostDoctoral';
import Publications from './Components/Pages/Publications';
import Bone from './Components/Pages/Bone';
import Tissue from './Components/Pages/Tissue';
import Biomimetics from './Components/Pages/Biomimatics';
import Gallery from './Components/Pages/Gallery';
import Ugstudents from './Components/Pages/Ugstudents';
import PhdStudents from './Components/Pages/PhdStudents';

function App() {
  return (
    <div className="flex-1 w-full max-w-6xl mx-auto bg-white shadow-md">
      <BrowserRouter basename={'/navin'}> 
        <Navbar/>
        <Routes>
          <Route element={<Home />} path="/" />
          <Route element={<Home />} path="/home" />
          <Route element={<Biography />} path="/biography" />
          <Route element={<Publications />} path="/publications" />
          <Route element={<Projects />} path="/projects" />
          <Route element={<Contact />} path="/contact" />
          <Route element={<News />} path="/news" />
          <Route element={<Internship />} path="/internship" />
          <Route element={<Faculty />} path="/faculty" />
          <Route element={<PostDoctoral />} path="/post-doctoral-fellow" />
          <Route element={<Bone />} path="/bone" />
          <Route element={<Tissue />} path="/tissue" />
          <Route element={<Biomimetics />} path="/biomimetics" />
          <Route element={<Gallery />} path="/gallery" />
          <Route element={<Ugstudents />} path="/ug-students" />
          <Route element={<PhdStudents />} path="/phd-students" />
        </Routes>
        <Footer/>  
      </BrowserRouter>
      
    </div>
  );
}

export default App;
